<template>
  <div class="p-6 bg-white rounded-lg">
    <h3 class="text-2xl font-medium mb-4 pb-2 border-b">Call To Action</h3>

    <input type="text" placeholder="Title" class="input-sm w-full mb-4" v-model="module.title" required>
    <textarea rows="3" class="input-sm w-full mb-4" placeholder="Description" v-model="module.settings.description" required></textarea>
    <input type="radio" :id="getTicketTypeId('email',module.id)" value='1' v-model="module.settings.ticket_type">
    <label class="text-sm mb-4" :for="getTicketTypeId('email',module.id)">Email</label>
    <input type="radio" :id="getTicketTypeId('pipeline',module.id)" value='2' v-model="module.settings.ticket_type">
    <label class="text-sm mb-4 ml-4" :for="getTicketTypeId('pipeline',module.id)">Hubspot Pipeline</label>
    <input type="email" placeholder="Recipient" class="input-sm w-full mb-4" v-model="module.settings.recipient" v-if="module.settings.ticket_type==='1'">

     <pl-select class="w-full mb-3" selectClass="select-sm" v-if="module.settings.ticket_type==='2'" v-model="module.settings.hubspot_pipeline">
          <option value=null>Select Hubspot Pipeline</option>
          <option value="4146445" v-if="system.networks[0].id===7 || system.networks[0].id===8">Fine & Country Support</option>
          <option value="4520257" v-if="system.networks[0].id===2">Guild Support</option>
          <option value="5051730" v-if="system.networks[0].id===7 || system.networks[0].id===8">Fine & Country Refined</option>
          <option value="6786181" v-if="system.networks[0].id===7 || system.networks[0].id===8 || system.networks[0].id===2">Studio</option>
          <option value="7775791" v-if="system.networks[0].id===7 || system.networks[0].id===8 || system.networks[0].id===2">Design</option>

    </pl-select>
    <input type="text" placeholder="Action" class="input-sm w-full mb-4" v-model="module.settings.action" required>

    <label class="text-sm mb-4" :for="getTicketTypeId('asset_title',module.id)">Upload Zone Title</label>
    <input type="text" :id="getTicketTypeId('asset_title',module.id)" placeholder="Upload Zone Title" class="input-sm w-full mb-4" v-model="module.settings.upload_title" required>
    <input type="checkbox" :id="getTicketTypeId('asset',module.id)" v-model="module.settings.include_upload">
    <label class="text-sm mb-4" :for="getTicketTypeId('asset',module.id)">Include Upload Option</label>
    <input type="checkbox" :id="getTicketTypeId('asset_required',module.id)" v-model="module.settings.include_upload_required">
    <label class="text-sm mb-4 ml-4" :for="getTicketTypeId('asset_required',module.id)">Upload is Required</label>
    <input type="checkbox" id="send_email_confirmaion" v-model="module.settings.send_email_confirmaion">
    <label class="text-sm mb-4 w-full" for="send_email_confirmaion">Send email confirmation</label>
    <label class="text-sm" v-if="module.settings.send_email_confirmaion">Confirmation Email Content</label>
    <textarea rows="3" class="input-sm w-full mb-4 mt-2" v-model="module.settings.confirmation_email_content" v-if="module.settings.send_email_confirmaion"></textarea>

    <h4 class="mt-6 mb-2">Form Fields</h4>
    <table class="table-auto w-full border-t border-b mb-6 text-left">
      <thead class="border-b uppercase text-xs">
        <th class="py-2 font-semibold">Label</th>
        <th class="py-2 pl-2 font-semibold">Type</th>
        <th class="py-2 pl-1 font-semibold text-center">Edit</th>
        <th class="py-2 pl-1 font-semibold text-center">Delete</th>
        <th colspan="2" class="py-2 pl-2 font-semibold text-center">Order</th>
      </thead>
      <tbody class="text-sm">
        <tr class="border-b" v-for="(element, index) in elements" :key="index">
          <td class="py-2">{{ element.label }}</td>
          <td class="py-2 pl-2 capitalize">{{ element.type }}</td>
          <td class="py-2 pl-1 text-center">
            <button type="button" class="no-underline text-black" @click="selectedElement = element">
              <i class="text-base mr-1 far fa-edit fa-fw" />
            </button>
          </td>
          <td class="py-2 text-center">
            <button type="button" class="no-underline text-black" @click="elements.splice(index, 1)">
              <i class="text-base mr-1 far fa-trash-alt fa-fw" />
            </button>
          </td>
          <td class="py-2 pl-1 text-center">
            <button type="button" class="w-5 h-5 hover:bg-grey-lighter border" :disabled="index==0" @click="moveModule(index,index-1)">
              <i class="fas fa-chevron-up"></i>
            </button>
          </td>
          <td class="py-2 pl-2 text-center">
            <button type="button" class="w-5 h-5 hover:bg-grey-lighter border" :disabled="index==(module.length-1)" @click="moveModule(index,index+1)">
              <i class="fas fa-chevron-down"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="py-2 text-center">
            <button @click="addElement" type="button" class="text-xs">
              <!-- class="mt-4 px-6 py-1 flex items-center justify-center text-sm text-grey-darkest rounded-lg shadow hover:shadow-none border border-blue bg-white" -->
              <span class="text-base mr-2">&#43;</span>
              Add Element
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <modal v-if="selectedElement" @leave="closeSettings">
      <button type="button" @click="closeSettings" class="absolute pin-t pin-r bg-white -mt-3 -mr-3 rounded-full border h-8 w-8 flex justify-center items-center">
        <i class="fas fa-times" />
      </button>

      <form @submit.prevent="save">
        <label for="element-type" class="label-sm">Type:</label>
        <pl-select name="element-type" id="element-type" v-model="selectedElement.type" class="w-full mb-3" selectClass="select-sm" required>
          <option value="text">Text</option>
          <option value="textarea">Textarea</option>
          <option value="select">Select</option>
        </pl-select>

        <label for="element-label" class="label-sm">Label:</label>
        <input type="text" name="element-label" id="element-label" class="input-sm w-full mb-3" v-model="selectedElement.label" required>

        <label v-if="hasPlaceholder(selectedElement)" for="element-placeholder" class="label-sm">Placeholder:</label>
        <input v-if="hasPlaceholder(selectedElement)" type="text" name="element-placeholder" id="element-placeholder" class="input-sm w-full mb-3" v-model="selectedElement.placeholder">

        <div v-if="hasOptions(selectedElement)">
          <label for="element-label" class="label-sm">Options:</label>
          <div v-for="(option, index) in selectedElement.options" :key="index" class="mb-2 ml-6 flex items-center">
            <input type="text" class="input-sm w-full mr-2" v-model="selectedElement.options[index]" required>
            <button @click="selectedElement.options.splice(index, 1)" type="button" class="bg-white rounded-full border h-6 w-6 flex justify-center items-center">
              <i class="fas fa-times fa-fw fa-sm" />
            </button>
          </div>

          <button @click="addOption(selectedElement)" type="button" class="mt-4 px-6 py-1 flex items-center justify-center text-sm text-grey-darkest rounded-lg shadow hover:shadow-none border border-blue bg-white">
            <span class="text-lg mr-2">&#43;</span>
            Add Option
          </button>
        </div>

        <input type="checkbox" class="w-full input-sm mb-4 mt-3"  name="element-required" id="element-required" v-model="selectedElement.required">
        <label for="element-required" class="text-grey-darkest text-sm font-normal mt-3">Is Required</label>

        <button type="submit" class="bg-secondary text-primary h-10 mt-6 px-4 uppercase text-xs font-medium w-full flex items-center justify-center">
          Done
        </button>
      </form>
    </modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: [ 'module' ],
  created () {
    if (this.module.settings === null) {
      this.$set(this.module, 'settings', {})
    }
  },
  data () {
    return {
      selectedElement: null
    }
  },
  computed: {
    elements () {
      return this.module.settings.elements
    },
    ...mapState(['system'])
  },
  methods: {
    save () {
      if (this.selectedElement) {
        delete this.selectedElement.isNew
        if (!this.hasOptions(this.selectedElement)) {
          delete this.selectedElement.options
        }
        console.log(this.selectedElement)
        this.selectedElement = null
      }
      console.log('saving... well not really')
    },
    addElement () {
      let element = { isNew: true, type: 'text', options: [''] }
      this.elements.push(element)
      this.selectedElement = element
    },
    hasPlaceholder (element) {
      return ['text', 'textarea'].indexOf(element.type) >= 0
    },
    hasOptions (element) {
      return ['select'].indexOf(element.type) >= 0
    },
    addOption (element) {
      if (element.options) {
        element.options.push('')
        return
      }

      this.$set(element, 'options', [''])
    },
    closeSettings () {
      if (this.selectedElement.isNew) {
        this.elements.splice(this.elements.indexOf(this.selectedElement), 1)
      }
      this.selectedElement = null
    },
    getTicketTypeId (type, id) {
      return type + '-' + id
    },
    moveModule (from, to) {
      this.elements.splice(to, 0, this.elements.splice(from, 1)[0])
    }
  }
}
</script>
